import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
//import '../src/assets/mhc-theme/fonts/Nunito-Regular.ttf';
import { Provider } from "react-redux";
import createStore, { RootState } from "../src/redux/store";
import { QueryClient, QueryClientProvider } from "react-query";
import { PersistGate } from "redux-persist/integration/react";
import { HttpRequestInterceptor, HttpResponseInterceptor } from "interceptors/HttpInterceptor";
import { StatusProvider } from "context/statusContext";

//import {auth} from './firebase-config';
//import { createUserWithEmailAndPassword, signInWithCredential, signInWithEmailAndPassword } from 'firebase/auth';

const { store, persistor } = createStore();
const defaultExport = [store, persistor];
export default defaultExport;

//console.log(auth);

const requestInterceptor = HttpRequestInterceptor;
const responseInterceptor = HttpResponseInterceptor;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense
            fallback={
              <div className="container-fluid">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            }
          >
            <StatusProvider>
              <App />
            </StatusProvider>
          </Suspense>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
